<template>
  <div class="aff-login-page">
    <div class="aff-login-card">
      <div class="aff-login-logo">
        <img src="/logo.png" alt="JILI" class="aff-logo-img" @error="$event.target.style.display='none'" />
        <h1>重設密碼</h1>
      </div>

      <div v-if="tokenInvalid" class="aff-error" style="margin-bottom:1rem">
        此連結已失效或過期，請重新申請。<br>
        <a href="/affiliate/forgot-password" style="color:#8B4513">重新申請忘記密碼</a>
      </div>

      <form v-else @submit.prevent="submit" class="aff-login-form">
        <div class="aff-field">
          <label>新密碼</label>
          <input v-model="password" type="password" placeholder="請輸入新密碼（至少 6 碼）" required minlength="6" />
        </div>
        <div class="aff-field">
          <label>確認新密碼</label>
          <input v-model="confirmPassword" type="password" placeholder="請再次輸入新密碼" required />
        </div>

        <div v-if="error" class="aff-error">{{ error }}</div>
        <div v-if="success" class="aff-success">{{ success }}</div>

        <button type="submit" class="aff-btn-login" :disabled="loading || !!success">
          {{ loading ? '更新中...' : '確認重設密碼' }}
        </button>

        <p v-if="success" class="aff-apply-link"><a href="/affiliate/login">前往登入</a></p>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'

const route = useRoute()
const token = route.query.token || ''
const password = ref('')
const confirmPassword = ref('')
const loading = ref(false)
const error = ref('')
const success = ref('')
const tokenInvalid = ref(!token)

async function submit() {
  error.value = ''
  if (password.value.length < 6) { error.value = '密碼至少需要 6 碼'; return }
  if (password.value !== confirmPassword.value) { error.value = '兩次輸入的密碼不一致'; return }
  loading.value = true
  try {
    const res = await axios.post('/api/affiliate/reset-password', {
      token,
      password: password.value
    })
    if (res.data.success) {
      success.value = '密碼已重設成功，請重新登入'
      password.value = ''
      confirmPassword.value = ''
    } else {
      error.value = res.data.message || '重設失敗'
    }
  } catch (e) {
    error.value = e.response?.data?.message || '連結已失效，請重新申請'
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  if (!token) tokenInvalid.value = true
})
</script>

<style scoped>
.aff-login-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f0eb 0%, #ede0d4 100%);
  display: flex; align-items: center; justify-content: center; padding: 2rem 1rem;
}
.aff-login-card {
  background: #fff; border-radius: 16px; box-shadow: 0 4px 24px rgba(0,0,0,0.10);
  padding: 2.5rem 2rem; width: 100%; max-width: 400px;
}
.aff-login-logo { text-align: center; margin-bottom: 1.5rem; }
.aff-logo-img { height: 48px; margin-bottom: 0.5rem; }
.aff-login-logo h1 { font-size: 1.4rem; color: #4a2c1a; margin: 0.3rem 0; }
.aff-login-form { display: flex; flex-direction: column; gap: 1rem; }
.aff-field { display: flex; flex-direction: column; gap: 0.3rem; }
.aff-field label { font-size: 0.85rem; font-weight: 600; color: #555; }
.aff-field input {
  border: 1px solid #ddd; border-radius: 8px; padding: 0.6rem 0.9rem;
  font-size: 0.95rem; outline: none; transition: border-color 0.2s;
}
.aff-field input:focus { border-color: #8B4513; }
.aff-error { background: #fff0f0; color: #c0392b; padding: 0.7rem 1rem; border-radius: 8px; font-size: 0.9rem; }
.aff-success { background: #f0fff4; color: #27ae60; padding: 0.7rem 1rem; border-radius: 8px; font-size: 0.9rem; }
.aff-btn-login {
  background: #8B4513; color: #fff; border: none; border-radius: 8px;
  padding: 0.8rem; font-size: 1rem; font-weight: 600; cursor: pointer; transition: background 0.2s;
}
.aff-btn-login:hover:not(:disabled) { background: #6b3310; }
.aff-btn-login:disabled { background: #ccc; cursor: not-allowed; }
.aff-apply-link { text-align: center; font-size: 0.88rem; color: #666; margin-top: 0.3rem; }
.aff-apply-link a { color: #8B4513; font-weight: 600; }
</style>
